import { apiClient, unwrap } from './client';
import type { ApiSuccess } from '@/types/api';
import type { AuthResult, LoginInput, RegisterInput, RefreshResult } from '@/types/auth';
import type { User } from '@/types/user';

export const authApi = {
  async login(input: LoginInput): Promise<AuthResult> {
    const res = await apiClient.post<ApiSuccess<AuthResult>>('/auth/login', input);
    return unwrap(res);
  },

  async register(input: RegisterInput): Promise<AuthResult> {
    const res = await apiClient.post<ApiSuccess<AuthResult>>('/auth/register', input);
    return unwrap(res);
  },

  async google(input: { credential: string }): Promise<AuthResult> {
    const res = await apiClient.post<ApiSuccess<AuthResult>>('/auth/google', input);
    return unwrap(res);
  },

  async refresh(): Promise<RefreshResult> {
    const res = await apiClient.post<ApiSuccess<RefreshResult>>('/auth/refresh');
    return unwrap(res);
  },

  async logout(): Promise<void> {
    await apiClient.post('/auth/logout');
  },

  /** Verify the current session — returns user (uses refresh cookie). */
  async me(): Promise<User> {
    const res = await apiClient.get<ApiSuccess<User>>('/users/me');
    return unwrap(res);
  },

  async verifyEmail(input: { token: string }): Promise<{ verified: boolean; email: string }> {
    const res = await apiClient.post<ApiSuccess<{ verified: boolean; email: string }>>(
      '/auth/verify-email',
      input,
    );
    return unwrap(res);
  },

  async resendVerification(input: { email: string }): Promise<void> {
    await apiClient.post('/auth/resend-verification', input);
  },

  async forgotPassword(input: { email: string }): Promise<void> {
    await apiClient.post('/auth/forgot-password', input);
  },

  async resetPassword(input: {
    token: string;
    newPassword: string;
  }): Promise<{ reset: boolean; email: string }> {
    const res = await apiClient.post<ApiSuccess<{ reset: boolean; email: string }>>(
      '/auth/reset-password',
      input,
    );
    return unwrap(res);
  },
};
